import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "mt-14 border-t border-black" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "mt-14" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "m-0" };
const _hoisted_6 = ["innerHTML"];
import { computed } from 'vue';
import ButtonWithArrow from '@atoms/ButtonWithArrow.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SpotlightForm',
    props: {
        termsButton: {},
        preFormText: {},
        step1Text: {},
        applicationButtons: {},
        step2Text: {}
    },
    setup(__props) {
        const props = __props;
        const displayTermsButton = computed(() => {
            return props.termsButton.text !== '' && props.termsButton.file;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (displayTermsButton.value)
                    ? (_openBlock(), _createBlock(ButtonWithArrow, {
                        key: 0,
                        text: _ctx.termsButton.text,
                        url: _ctx.termsButton.file.link,
                        target: "_blank",
                        class: "!font-sans text-sm !font-bold"
                    }, null, 8, ["text", "url"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_1, [
                    (_ctx.preFormText)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "pt-10",
                            innerHTML: _ctx.preFormText
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", { innerHTML: _ctx.step1Text }, null, 8, _hoisted_4),
                    _createElementVNode("p", _hoisted_5, [
                        (_ctx.applicationButtons)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.applicationButtons, (button) => {
                                return (_openBlock(), _createBlock(ButtonWithArrow, {
                                    text: button.text,
                                    url: button.file.link,
                                    target: "_blank",
                                    class: "mt-6 !font-sans text-sm !font-bold"
                                }, null, 8, ["text", "url"]));
                            }), 256))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                        class: "mt-14",
                        innerHTML: _ctx.step2Text
                    }, null, 8, _hoisted_6)
                ])
            ]));
        };
    }
});
